module.exports = __webpack_public_path__ + "42335b24fa41abd5f052f34ad5aa7f32.png";